module.exports = __webpack_public_path__ + "img/Monk.338c2fdb.png";